import { useState } from 'react'
import { RichTextEditor } from '@/components/RichTextEditor'
import { FormField } from '@/components/ui/form-field'
import { Input } from '@/components/ui/input'
import { NativeSelect } from '@/components/ui/native-select'
import { ACTIVITY_LABEL } from '../reviewModel'
import type { ActivityKind, ActivityProposal } from '../types'
import { SheetFrame } from './SheetFrame'

const KINDS: ActivityKind[] = ['call', 'meeting', 'email', 'note']

/** Edit a proposed activity: type, date, title, "Met" (read-only here: it follows "Wie") and the report. */
export function ActivitySheet({
  activity,
  withText,
  onSave,
  onClose,
}: {
  activity: ActivityProposal
  withText: string | null
  onSave: (values: Record<string, unknown>) => void
  onClose: () => void
}) {
  const [type, setType] = useState<ActivityKind>(activity.type)
  const [day, setDay] = useState(activity.occurred_on)
  const [title, setTitle] = useState(activity.title ?? '')
  const [html, setHtml] = useState(activity.body_html)
  return (
    <SheetFrame
      title="Verslag bewerken"
      onClose={onClose}
      saveDisabled={!day}
      onSave={() => onSave({ type, occurred_on: day, title: title.trim() || null, body_html: html })}
    >
      <FormField label="Soort">
        <NativeSelect value={type} onChange={(event) => setType(event.target.value as ActivityKind)}>
          {KINDS.map((kind) => (
            <option key={kind} value={kind}>
              {ACTIVITY_LABEL[kind]}
            </option>
          ))}
        </NativeSelect>
      </FormField>
      <FormField label="Datum" required>
        <Input type="date" value={day} onChange={(event) => setDay(event.target.value)} />
      </FormField>
      <FormField label="Titel">
        <Input value={title} maxLength={200} onChange={(event) => setTitle(event.target.value)} />
      </FormField>
      {withText ? (
        <FormField label="Met" hint="Verander dit onder Wie.">
          <p className="text-base">{withText}</p>
        </FormField>
      ) : null}
      <div className="flex flex-col gap-1.5">
        <span className="text-sm font-semibold">Verslag</span>
        <RichTextEditor format="html" value={html} onChange={(value) => setHtml(value)} ariaLabel="Verslag" />
      </div>
    </SheetFrame>
  )
}
